// extracted by mini-css-extract-plugin
export default {"selected":"dropdownStyling_selected__LROAt"};